module.exports = __webpack_public_path__ + "media/images/watch/bookmarks-6958462fddf1ba388e49478b57385a45.svg";